import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoDetailColumnTable } from 'app/shared/models/commission/dto-detail-column-table.model';
import Handsontable from 'handsontable';
import { HotTableComponent, HotTableRegisterer } from '@handsontable/angular';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { PayrollService } from '../../payroll.service';
import { IDtoPayrollDetail } from 'app/shared/models/payroll/dto-payroll-detail.model';
import { IDtoPayrollDetailAttend } from 'app/shared/models/payroll/dto-payroll-detail-attend.model';
import { ISelect } from 'app/shared/models/select.model';
import { OpeningService } from '../../opening/opening.service';
import { IResult } from 'app/shared/models/result.model';
import { registerLanguageDictionary, esMX } from 'handsontable/i18n';
import { IDtoPayroll } from 'app/shared/models/payroll/dto-payroll.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalRetentionsComponet } from 'app/views/modales/payroll/retentions/modal-retentions.component';
import { IDtoRetentionEmail } from 'app/shared/models/payroll/dto-retention-email.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoMovementRestrictionCalendar } from 'app/shared/models/payroll/dto-movement-restriction-calendar.model';
@Component({
    selector: 'app-payroll-detail',
    styleUrls: ['./payroll-detail.style.scss'],
    templateUrl: 'payroll-detail.template.html'
})

export class PayrollDetailComponent implements OnInit {
    private hotId: string = 'commissions';
    /**Securty */
    private showRoles: any;
    private employeeIniId: string;
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Variables */
    private now: number;
    private action = '';
    private payrollId: string;
    private module: string;
    private routeType: string;
    /**Objetos*/
    private columns: IDtoDetailColumnTable[];
    private detailTotal: any[] = [];
    /**Notificaciones */
    private configToast: any;
    tableSettings: {};
    private headerDetail: any;
    @ViewChild("hot2", { static: false }) hot2: HotTableComponent;
    @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
    @ViewChild('concludedSwal', { static: false }) private concludedSwal: SwalComponent;
    @ViewChild('conLockSwal', { static: false }) private conLockSwal: SwalComponent;
    private catalogSupervisors: ISelect[];
    private catalogRetentions: IDtoCatalog[];
    private payroll: IDtoPayroll;
    private isOpenPeriod: boolean;
    private profile: string;
    private symbology = ['A', 'F', 'I', 'B', 'V', 'D', 'E', 'DL', 'DT', 'DTD', 'FS', 'X'];
    private modalRef: BsModalRef;
    private restrictionRetentionExist
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private modified = [] as number[];
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private route: ActivatedRoute
        , private spinner: NgxSpinnerService
        , private openingService: OpeningService
        , private payrollService: PayrollService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private hotRegisterer: HotTableRegisterer
        , private modalService: BsModalService) {
        Handsontable.renderers.registerRenderer('rendererCellByValue', rendererCellByValue);
        Handsontable.renderers.registerRenderer('firstRowRenderer', firstRowRenderer);
        registerLanguageDictionary(esMX);
        this.configToast = configGeneral.getConfigToast();
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
            this.profile = this.securityService.getProfileStorage('Payroll');
        }
    }
    ngOnInit(): void {
        const that = this;
        this.now = Date.now();
        this.route.params.subscribe((params) => {
            if (params['id']) {
                setTimeout(() => {
                    this.spinner.show();
                    if (this.configurationService.isReady) {
                        this.payrollId = params['id'];
                        this.module = params['module'];
                        this.routeType = params['routeType'];
                        this.openingService.getCatalogSupervisors().subscribe(x => { this.catalogSupervisors = x; this.getPayrollDetails(); this.getCatalogRetention();});
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            this.payrollId = params['id'];
                            this.module = params['module'];
                            this.routeType = params['routeType'];
                            this.openingService.getCatalogSupervisors().subscribe(x => { this.catalogSupervisors = x; this.getPayrollDetails();this.getCatalogRetention();});
                        });
                    }
                }, 2);
            }
        });
    }
    private getCatalogRetention(): void {
      this.payrollService.getCatalogRetention().subscribe(res => {
        this.catalogRetentions = res;
      });
    }
    settings: Handsontable.GridSettings = {
        data: [/* some data */]
    }
    private updatePayrollOverallStatus(): void {
        this.spinner.show();
        let dto = {} as IDtoPayroll;
        dto.id = Number(this.payrollId);
        dto.isLocked = false;

        this.payrollService.updatePayrollLocked(dto).subscribe(
            (x) => {
                if (this.configGeneral.notificationSuccessError(x)) {
                }
                window.location.reload();
                this.spinner.hide();
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private updatePayrollDetails() {
        this.payrollService.validatePayrolldLock(this.headerDetail.payrollId, this.profile).subscribe(res => {
            let result = res.data.toString().split(',');
            if (result[0] == "2" && result[1] == 'True') {
                this.conLockSwal.title = '!Período bloqueado, no se permite actualizar.!';
                this.conLockSwal.show();
                this.isOpenPeriod = false;
                return;
            }
            else {
                this.confirmSwal.title = 'La información será actualizada. ¿Seguro que desea continuar?';
                this.confirmSwal.show().then((result) => {
                    if (result.value) {
                        this.spinner.show();
                        let numColumns = this.columns.length;
                        let details = [] as IDtoPayrollDetail[];
                        let isSave = true;
                        let validateComment = false as boolean;
                        let validateRetention = false as boolean;
                        let listErrorComments: string[] = [];
                        const uniqueModifiedIndices = Array.from(new Set(this.modified));
                        let detailModified = uniqueModifiedIndices.map(index => this.detailTotal[index]);
                        detailModified.forEach(element => {
                                let d = {} as IDtoPayrollDetail;
                                d.payrollDetailAttends = [];
                                let id = element.payrollDetailId;
                                d.payrollId = element.payrollId;
                                d.id = id;
                                d.bonusValue = element.bonusValue;
                                d.commissionValue = element.commissionValue;
                                d.discountValue = element.discountValue;
                                d.retroactiveValue = element.retroactiveValue;
                                d.pendingDays = element.pendingDays;
                                d.isRetention = element.isRetention;
                                d.comment = element.comment;
                                d.userEmployeeId = Number(this.employeeIniId);

                                if (d.comment != undefined) {
                                    if (d.comment.length > 200) {
                                        isSave = false;
                                        validateComment = true;
                                        listErrorComments.push(element.employeeName);
                                    }
                                }
                                if (element.isRetention) {
                                    if (element.retentionName == null) {
                                        isSave = false;
                                        validateRetention = true;
                                    } else {
                                      let retencion = this.catalogRetentions.filter(c => c.name === element.retentionName)[0];
                                      if (retencion == null){
                                        isSave = false;
                                        validateRetention = true;
                                      }
                                      else{
                                      d.retentionName = element.retentionName;
                                      }
                                    }
                                }
                                for (var v = 9; v < numColumns - 9; v++) {
                                    let c = this.columns[v];
                                    Object.entries(element).forEach(entry => {
                                        const [key, value] = entry;
                                        if (key == c.data) {
                                          if (this.symbology.includes(value as string)) {
                                            let da = {} as IDtoPayrollDetailAttend;
                                            da.payrollDetailId = id
                                            da.order = +c.data;
                                            da.value = value as string;
                                            d.payrollDetailAttends.push(da)
                                          }
                                        }
                                    });
                                }
                                details.push(d);
                        });
                        if (isSave) {

                            this.actualizarListaEnBloques(details, 50);
                        } else {
                            if (validateRetention) {
                                this.configGeneral.newToast('Error', 'Seleccione un motivo de retención valido para los registros marcados como retenidos', 'error');
                                this.spinner.hide();
                            }

                            if (validateComment) {
                              console.log('validateComment entra',validateComment)
                                listErrorComments.forEach(element => {
                                    this.configGeneral.newToast('Error', 'Comentarios exceden numero de caracteres del empleado:' + element, 'error');
                                });
                                this.spinner.hide();
                            }
                        }
                    }
                });
            }
        });
    }
    async actualizarListaEnBloques(list: IDtoPayrollDetail[], tamanoBloque: number) {
        try {
            const resultados = await this.payrollService.actualizarLista(list, tamanoBloque);
            let error = resultados.filter(r => r.exito == false);
            if (error.length > 0) {
                this.concludedSwal.title = '!El proceso no se completó correctamente!';
                this.concludedSwal.type = 'warning';
            } else {
                this.modified = [];
                this.concludedSwal.title = '!Proceso terminado con éxito!';
                this.concludedSwal.type = 'success';
            }
            this.concludedSwal.show();
            this.spinner.hide();
            this.settings.data = this.detailTotal;
        } catch (error) {
            this.concludedSwal.title = '!El proceso no se completó correctamente!';
            this.concludedSwal.type = 'warning';
            this.concludedSwal.show();
        }
    }
    private openModalRetentions(list: IDtoRetentionEmail[], details: IDtoPayrollDetail[]) {
        const initialState = {
            employees: list,
        };

        this.modalRef = this.modalService.show(ModalRetentionsComponet
            , Object.assign({ initialState }
                , { class: 'modal-lg' }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                let employees = result as IDtoRetentionEmail[];
                let values = [];
                values.push(details);
                values.push(employees);
                this.payrollService.removeRetentions(values)
                    .subscribe(
                        (x) => {
                            if (this.configGeneral.notificationSuccessError(x)) {
                                //this.updateEmployeePayroll();
                            }
                            this.spinner.hide();
                        },
                        (errMessage) => {
                            this.spinner.hide();
                            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                        });
                this.settings.data = this.detailTotal;
            }
        });
    }
    private removeRetentions() {
        this.confirmSwal.title = 'Las retenciones desmarcadas serán liberadas, este proceso es irreversible. ¿Seguro que desea continuar?';
        this.confirmSwal.show().then((result) => {
            if (result.value) {
                //this.spinner.show();
                let numColumns = this.columns.length;
                let details = [] as IDtoPayrollDetail[];
                let retentionEmails = [] as IDtoRetentionEmail[];
                let isSave = true;
                this.detailTotal.forEach(element => {
                    if (element.isRetention == false) {
                        let d = {} as IDtoPayrollDetail;
                        let employee = {} as IDtoRetentionEmail;
                        d.payrollDetailAttends = [];
                        let id = element.payrollDetailId;
                        d.payrollId = element.payrollId;
                        d.id = id;
                        d.bonusValue = element.bonusValue;
                        d.commissionValue = element.commissionValue;
                        d.discountValue = element.discountValue;
                        d.retroactiveValue = element.retroactiveValue;
                        d.pendingDays = element.pendingDays;
                        d.isRetention = element.isRetention;
                        d.totalDays = element.totalDays;
                        d.comment = element.comment;
                        for (var v = 9; v < numColumns - 9; v++) {
                            let c = this.columns[v];
                            Object.entries(element).forEach(entry => {
                                const [key, value] = entry;
                                if (key == c.data) {
                                    let da = {} as IDtoPayrollDetailAttend;
                                    da.payrollDetailId = id
                                    da.order = +c.data;
                                    da.value = value as string;
                                    d.payrollDetailAttends.push(da)
                                }
                            });
                        }
                        details.push(d);
                        employee.employee = element.employeeName;
                        employee.payrollDetailId = id;
                        retentionEmails.push(employee);
                    }
                });
                if (details.length < 1 || retentionEmails.length < 1) {
                    this.configGeneral.newToast('Error', 'No existen datos modificados para procesar', 'error');
                    this.spinner.hide();
                    return;
                }
                this.openModalRetentions(retentionEmails, details);
            }
        });
    }
    private getPayrollDetails(): void {
        this.payrollService.getPayrollDetailsByPayrollId(this.payrollId, +this.employeeIniId, this.profile, this.module, this.routeType).subscribe((res) => {
            if (!res.isCorrect) {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
                return;
            }
            this.processDetail(res);
            this.spinner.hide();
        });
    }
    private getPayrollDetailsBySupervisor(item: ISelect): void {
        if (item == null) {
            this.spinner.show();
            this.getPayrollDetails();
            return;
        }
        this.spinner.show();
        this.payrollService.getPayrollDetailsByPayrollIdAndSupervisorId(this.payroll.id, +item.id, +this.employeeIniId, this.profile, this.module).subscribe((res) => {
            if (!res.isCorrect) {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
                return;
            }
            this.processDetail(res);
            this.spinner.hide();
        });
    }
    private processDetail(res: IResult): void {
        let listSupervisors = res.data[2];
        this.payroll = res.data[3];

        if (this.payroll.isLocked == true && this.payroll.statusName == 'Cerrada') {
            this.payroll.statusNameTitle = this.payroll.statusName + "/" + this.payroll.statusNameTitle + "/Bloqueada"
        }
        else if (this.payroll.isLocked == false && this.payroll.statusName == 'Cerrada') {
            this.payroll.statusNameTitle = this.payroll.statusName + "/" + this.payroll.statusNameTitle + "/Desbloqueada"
        }
        else if (this.payroll.statusName == 'Abierta') {
            this.payroll.statusNameTitle = this.payroll.statusName + "/" + this.payroll.statusNameTitle
        }

        this.catalogSupervisors = this.catalogSupervisors.filter(x => listSupervisors.includes(+x.id));
        this.detailTotal = res.data[0];// as any[];
        this.headerDetail = this.detailTotal[0];
        this.columns = res.data[1];// as IDtoCommissionDetailColumnTable[];
        let comments = res.data[4];
        //this.showItems(this.detailTotal);
        this.tableSettings = {
            data: this.detailTotal,
            columns: this.columns,
            rowHeaders: true,
            colHeaders: true,
            stretchH: 'all',
            width: '100%',
            height: 360,
            language: 'es-MX',
            filters: true,
            manualColumnResize: true,
            fixedColumnsLeft: 3,
            //contextMenu: true,
            dropdownMenu: [
                'filter_by_condition',
                '---------',
                'filter_operators',
                '---------',
                'filter_by_condition2',
                '---------',
                'filter_by_value',
                '---------',
                'filter_action_bar'
            ],
            hiddenColumns: {
                columns: this.profile == 'Administrador' ? [0,] : [0, 5]

            },
            licenseKey: 'non-commercial-and-evaluation',
            afterChange: (changes, src) => {
                if (changes != null) {
                    let column = changes[0][1];
                    let affterVal = changes[0][2];
                    let currentVal = changes[0][3];
                    let i = changes[0][0];
                    let col = this.columns.filter(x => x.data == column)[0];
                    let numColumnEdit = this.columns.indexOf(col);
                    let numColumns = this.columns.length;

                    let visibleRowIndex = changes[0][0];
                    let physicalRowIndex = this.hotRegisterer.getInstance(this.hotId).toPhysicalRow(visibleRowIndex);

                    if (column == 'isRetention') {
                        if (currentVal == false) {
                            this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumnEdit + 1, null);
                        }
                    } else if (column != 'isRetention' || column != 'retentionName') {
                        let currentVal = changes[0][3];

                        if (changes.length > 1){
                            for (let e = 0; e < changes.length; e++) {
                                let column1 = changes[e][1];
                                let affterVal1 = changes[e][2];
                                let currentVal1 = changes[e][3];

                                let visibleRowIndex1 = changes[e][0];
                                let physicalRowIndex1 = this.hotRegisterer.getInstance(this.hotId).toPhysicalRow(visibleRowIndex1);

                                if (currentVal1 == 'V' || currentVal1 == 'I' || currentVal1 == 'B'|| currentVal1 == 'N'|| currentVal1 == 'X') {
                                    this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumnEdit + e, affterVal1);
                                } else {
                                    this.modified.push(physicalRowIndex1);
                                }
                            }
                        }
                        else{
                        if (currentVal == 'V' || currentVal == 'I' || currentVal == 'B'|| currentVal == 'N'|| currentVal == 'X') {
                            this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumnEdit, affterVal);
                        } else {
                          if(changes[0][1] != 'totalDays')
                            this.modified.push(physicalRowIndex);
                        }
                    }
                    }
                    if (column != 'totalDays') {
                        let data = this.hotRegisterer.getInstance(this.hotId).getDataAtRow(i) as any;
                        let totalDays = 0;
                        for (var v = 9; v < numColumns - 9; v++) {
                            let value = data[v];
                            if (value == "A"
                                || value == "V"
                                || value == "DL"
                                || value == "DT"
                                || value == "E"
                                || value == "DTD"
                                || value == "FS"
                                || value == "D") {
                                totalDays++;
                            }
                        }
                        this.hotRegisterer.getInstance(this.hotId).setDataAtCell(i, numColumns - 9, totalDays);
                    }
                }
            },
            cells(row, col) {
                const data = this.instance.getData();

                if (data[row] && data[row][col] === 'A'
                    || data[row] && data[row][col] === 'F'
                    || data[row] && data[row][col] === 'I'
                    || data[row] && data[row][col] === 'B'
                    || data[row] && data[row][col] === 'V'
                    || data[row] && data[row][col] === 'D'
                    || data[row] && data[row][col] === 'E'
                    || data[row] && data[row][col] === 'DL'
                    || data[row] && data[row][col] === 'DT'
                    || data[row] && data[row][col] === 'DTD'
                    || data[row] && data[row][col] === 'FS'
                    || data[row] && data[row][col] === 'X'
                    || data[row] && data[row][col] === 'N') {
                    const cellProperties = {} as any;
                    cellProperties.renderer = 'rendererCellByValue';
                    if (data[row] && data[row][col] === 'I'
                        || data[row] && data[row][col] === 'V'
                        || data[row] && data[row][col] === 'B'
                        || data[row] && data[row][col] === 'N'
                        || data[row] && data[row][col] === 'X') {
                        cellProperties.readOnly = true;
                    }
                    return cellProperties;
                }
            },
            comments: true,
            cell: comments,
        }
        this.hot2.updateHotTable(this.tableSettings);
        this.getRestrictionPayroll();
    }
    private updateEmployees(): void {
        this.payrollService.validatePayrolldLock(Number(this.payrollId), this.profile).subscribe(res => {
            let result = res.data.toString().split(',');
            if (result[0] == "2" && result[1] == 'True') {
                this.conLockSwal.title = '!Período bloqueado, no se permite actualizar.!';
                this.conLockSwal.show();
                this.isOpenPeriod = false;
                return;
            }
            else {
                this.confirmSwal.title = 'Esta operación ingresará empleados que no se encuentren actualmente en la prenomina. ¿Seguro que desea continuar?';
                this.confirmSwal.show().then((result) => {
                    if (result.value) {
                        this.spinner.show();
                        this.payrollService.validateEmployessPayroll(this.payroll.id)
                            .subscribe(
                                (x) => {
                                    if (x.isCorrect) {
                                        this.configGeneral.newToast('Éxito', x.message, 'success');
                                    } else {
                                        this.configGeneral.newToast('Error', x.message, 'error');
                                    }
                                    this.spinner.hide();
                                },
                                (errMessage) => {
                                    this.spinner.hide();
                                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                                });
                    }
                });
            }
        });
    }
    private sendPayrollNom(): void {
        this.confirmSwal.title = 'Se enviará el contenido de esta prenomina a NOM2001. Este proceso es irreversible. ¿Seguro que desea continuar?';
        this.confirmSwal.show().then((result) => {
            if (result.value) {
                this.spinner.show();
                this.payrollService.sendPayrollNom(this.payroll.id)
                    .subscribe(
                        (x) => {
                            if (x.isCorrect) {
                                this.configGeneral.newToast('Éxito', x.message, 'success');
                                location.reload();
                            } else {
                                this.configGeneral.newToast('Error', x.message, 'error');
                            }
                            this.spinner.hide();
                        },
                        (errMessage) => {
                            this.spinner.hide();
                            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                        });
            }
        });
    }

    private getRestrictionPayroll(): void {
      let restriction = {} as IDtoMovementRestrictionCalendar;
      restriction.payrollTypeId = this.payroll.payrollTypeId;
      restriction.currentDate = this.configGeneral.getLocalISOTime(new Date(this.now));
      restriction.movementType = 9;
      this.payrollService.restrictionExistCalendar(restriction).subscribe(x => {
            this.restrictionRetentionExist = x;
      });
  }
}
function firstRowRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.fontWeight = 'bold';
  td.style.background = '#E6E5E5';
}
function rendererCellByValue(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);

    if (value === 'A') {
        td.style.fontWeight = 'bold';
    } else if (value === 'F') {
        td.style.fontWeight = 'bold';
        td.style.background = '#FF0000';
    } else if (value === 'E') {
        td.style.fontWeight = 'bold';
        td.style.color = '#FFFFFF';
        td.style.background = '#9C2828';
    } else if (value === 'I') {
        td.style.fontWeight = 'bold';
        td.style.background = '#00B0F0';
    } else if (value === 'B') {
        td.style.fontWeight = 'bold';
        td.style.background = '#FFC000';
    } else if (value === 'V') {
        td.style.fontWeight = 'bold';
        td.style.background = '#00B050';
    } else if (value === 'D') {
        td.style.fontWeight = 'bold';
        td.style.background = '#757171';
    } else if (value === 'DL') {
        td.style.fontWeight = 'bold';
        td.style.background = '#FFFF00';
    } else if (value === 'DT') {
        td.style.fontWeight = 'bold';
        td.style.background = '#9370DB';
    } else if (value === 'DTD') {
        td.style.fontWeight = 'bold';
        td.style.background = '#FF1392';
    } else if (value === 'FS') {
        td.style.fontWeight = 'bold';
        td.style.color = '#FFFFFF';
        td.style.background = '#7030A0';
    } else if (value === 'X') {
        td.style.fontWeight = 'bold';
        td.style.color = '#FFFFFF';
        td.style.background = '#1E1E1E';
    } else if (value === 'N') {
        td.style.fontWeight = 'bold';
        td.style.background = '#00215E';
    }
}

